import { render } from "./BannerSuperior.vue?vue&type=template&id=1852edde&scoped=true"
import script from "./BannerSuperior.vue?vue&type=script&lang=js"
export * from "./BannerSuperior.vue?vue&type=script&lang=js"

import "./BannerSuperior.vue?vue&type=style&index=0&id=1852edde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1852edde"]])

export default __exports__